(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-atc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initStickyATC(root) {
      if (!root || root.dataset.stickyAtcInit) return;
      root.dataset.stickyAtcInit = 'true';

      var trigger = parseInt(root.dataset.scrollTrigger || '30', 10);
      var action = root.dataset.action;
      var button = root.querySelector('.sticky-atc__button');

      function scrollPercent() {
        var doc = document.documentElement;
        var scrollTop = window.scrollY || doc.scrollTop;
        var height = doc.scrollHeight - doc.clientHeight;
        if (height <= 0) return 0;
        return (scrollTop / height) * 100;
      }

      function onScroll() {
        if (scrollPercent() >= trigger) {
          root.classList.add('is-visible');
        } else {
          root.classList.remove('is-visible');
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();

      if (!button) return;

      button.addEventListener('click', function () {
        if (action === 'link') {
          var url = root.dataset.link;
          if (url) window.location.href = url;
          return;
        }

        if (action === 'scroll_top') {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return;
        }

        if (action === 'add_to_cart') {
          var variantId = root.dataset.variantId;
          if (!variantId) return;

          button.dataset.loading = 'true';
          var originalText = button.textContent;
          button.textContent = 'Toevoegen...';

          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          })
            .then(function (res) {
              if (!res.ok) throw new Error('Add to cart failed');
              return res.json();
            })
            .then(function () {
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

              // Probeert een bestaande cart-drawer/notification te openen als die aanwezig is.
              // Controleer dit tegen jouw eigen cart-drawer element in Trade en pas aan indien nodig.
              var drawer = document.querySelector('cart-drawer, cart-notification');
              if (drawer && typeof drawer.open === 'function') {
                drawer.open();
              } else if (drawer && typeof drawer.renderContents === 'function') {
                fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
                  .then(function (r) { return r.text(); })
                  .then(function (html) {
                    drawer.renderContents({ sections: { 'cart-drawer': html } });
                  });
              }

              button.textContent = 'Toegevoegd ✓';
              setTimeout(function () {
                button.textContent = originalText;
                delete button.dataset.loading;
              }, 1800);
            })
            .catch(function () {
              button.textContent = originalText;
              delete button.dataset.loading;
              window.location.href = window.Shopify.routes.root + 'cart';
            });
        }
      });
    }

    document.querySelectorAll('.sticky-atc').forEach(initStickyATC);

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('.sticky-atc');
      if (root) initStickyATC(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
